module.exports = __webpack_public_path__ + "img/15-kastehelmi.4436a430.jpg";